import { GetClientSettings } from "./SettingsService";
import { ISalvageClientSettings } from "../interfaces/ISalvageClientSettings";
import { useReadonlyData } from "./useVersionedData";
import { IAddress } from "../interfaces/IAddress";

const ClientSettings: ISalvageClientSettings = GetClientSettings();

export interface ReceiptData {
  id: string;
  isRefund: boolean;
  nsgLogoUrl: string;
  nsgAddress: IAddress;
  salvageMarketLogoUrl: string;
  nsgPhoneNumber: string;
  nsgEmail: string;
  bidderName: string;
  bidderBusiness: string | null;
  bidderAddress: IAddress;
  bidderPhoneNumber: string;
  bidderEmail: string;
  saleDate: Date;
  refundedDate: Date;
  saleReceiptNumber: string;
  referenceNumber: string;
  expiryDate: Date | null;
  subscriptionLength: number;
  memberName: string;
  memberWebsiteUrl: string;
  memberAddress: IAddress;
  memberPhoneNumber: string;
  memberEmail: string;
  totalExVat: number;
  vat: number;
  totalIncVat: number;
  paymentType: string;
  transactionNumber: string;
  registeredCompany: string;
  registeredCountry: string;
  companyRegistrationNumber: string;
  vatRegistrationNumber: string;
  orderDescription: string;
  orderStatus: string;
  isEligibleForRefund: boolean;
  orderCurrentStatus: string;
  refundAllowed: boolean;
}

export const useMemberPaymentReceipt = (orderId: string, onError: (httpStatusCode: number, resultBody?: string) => void) =>
  useReadonlyData<ReceiptData>(`${ClientSettings.UsersPrivateApiUrl}/member/receipts/${orderId}`, onError);

export const useAllBidderReceiptsForMember = (bidderId: string, onError: (httpStatusCode: number, resultBody?: string) => void) =>
  useReadonlyData<ReceiptData[]>(`${ClientSettings.UsersPrivateApiUrl}/member/receipts/all/bidder/${bidderId}`, onError);
